import { render, staticRenderFns } from "./CourseMemberPage.vue?vue&type=template&id=1bcf8ab2&scoped=true"
import script from "./CourseMemberPage.vue?vue&type=script&lang=js"
export * from "./CourseMemberPage.vue?vue&type=script&lang=js"
import style0 from "./CourseMemberPage.vue?vue&type=style&index=0&id=1bcf8ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf8ab2",
  null
  
)

export default component.exports